import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const SettingsGlyph = /*#__PURE__*/createElement("g", {
  id: "settings"
}, /*#__PURE__*/createElement("path", {
  d: "M67.74 26.67H48.76v-2.95c0-.55-.45-1-1-1H43.8c-.55 0-1 .45-1 1v2.95H16.26c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5H42.8v2.95c0 .55.45 1 1 1h3.96c.55 0 1-.45 1-1v-2.95h18.98c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5zM67.74 54.33H56.68v-2.95c0-.55-.45-1-1-1h-3.96c-.55 0-1 .45-1 1v2.95H16.26c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5h34.46v2.95c0 .55.45 1 1 1h3.96c.55 0 1-.45 1-1v-2.95h11.07c.83 0 1.5-.67 1.5-1.5s-.68-1.5-1.51-1.5zM67.74 40.5H34.12v-2.95c0-.55-.45-1-1-1h-3.96c-.55 0-1 .45-1 1v2.95h-11.9c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5h11.91v2.95c0 .55.45 1 1 1h3.96c.55 0 1-.45 1-1V43.5h33.62c.83 0 1.5-.67 1.5-1.5s-.68-1.5-1.51-1.5z"
}));
const Settings = createSvg({
  name: 'settings',
  path: SettingsGlyph
});

export default Settings;
export { SettingsGlyph };
